import React, { useEffect, useState, Fragment } from "react";
import "../src/Styles/Pages/pmorderprocessing.scss";
import withAppData from "../src/HOC/withAppData";
import Loading from "../src/Loaders/Loading";
import { _formatCurrency } from "../src/Utils/helpers";

const DriverReconPayment = (props) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);
  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Fragment>
          <div className="pm-recon-payment">
            <div className="pm-recon-payment-top-info flex flex-between">
              <div className="flex flex-between pm-recon-payment-top-info-card">
                <p className="bold">Deliveries Values</p>
                <span>
                  {_formatCurrency(
                    props.driverReconcilationDetails.deliveriesValue || 0
                  )}{" "}
                </span>
              </div>
              <div className="flex flex-between pm-recon-payment-top-info-card">
                <p className="bold">Amount Collected</p>
                <span>
									{_formatCurrency(
										(props.driverReconcilationDetails.driverCash || 0) +
											(props.driverReconcilationDetails.driverDeposit || 0) +
											(props.totalVirtualAmount || 0) + 
											(props.totalDriverVaBalance || 0),
									)}
								</span>{" "}
              </div>
              <div className="flex flex-between pm-recon-payment-top-info-card">
                <p className="bold">RTO</p>
                <span>
                  {_formatCurrency(props.driverReconcilationDetails.rto || 0)}
                </span>
              </div>
              <div className="flex flex-between pm-recon-payment-top-info-card">
                <p className="bold">Resell Value</p>
                <span>
                  {_formatCurrency(
                    props.driverReconcilationDetails.resellValue || 0
                  )}
                </span>
              </div>
            </div>
            <div style={{ textAlign: "left", margin: "50px 0px 20px 0px" }}>
              Payment Options
            </div>
            <div className="driver-upload-category green-bg">
              <div className="label-container field">
                <label>OmniPay Account</label>
              </div>
              <div className="label-container value">
              <label>
									{_formatCurrency(
										(props.totalVirtualAmount || 0) + (props.totalDriverVaBalance || 0),
									)}
								</label>
              </div>
            </div>
            <div className="driver-upload-category blue-bg">
              <div className="label-container field">
                <label>Deposit(Wallet, Bank, etc.)</label>
              </div>
              <div className="label-container value">
                <label>
                  {_formatCurrency(
                    props.driverReconcilationDetails.driverDeposit || 0
                  )}
                </label>
              </div>
            </div>
            {props.driverReconcilationDetails.IsDriverLogin !== 1 && (
              <div className="driver-upload-category orange-bg">
                <div className="label-container field">
                  <label>Cash at hand</label>
                </div>
                <div className="label-container value">
                  <label>
                    {_formatCurrency(
                      props.driverReconcilationDetails.driverCash || 0
                    )}
                  </label>
                </div>
              </div>
            )}
            {Number(props.driverReconcilationDetails.PayLaterAmount || 0) >
              0 && (
              <div className="driver-upload-category purple-bg">
                <div className="label-container field">
                  <label>PayLater</label>
                </div>
                <div className="label-container value">
                  <label>
                    {_formatCurrency(
                      props.driverReconcilationDetails.PayLaterAmount || 0
                    )}
                  </label>
                </div>
              </div>
            )}
            <div className="pm-recon-payment-card">
              <div className="pm-recon-payment-options">
                <div className="pm-recon-payment-outstanding">
                  <div
                  className="pm-recon-payment-outstanding-title"
                    // style={{
                    //   color: "#1a1d1f",
                    //   fontWeight: "bold",
                    //   fontSize: "15px",
                    //   marginTop: "16px",
                    //   textAlign: "left",
                    //   padding: "15px",
                    // }}
                  >
                    Outstanding Details
                  </div>

                  <section className="pm-recon-payment-outstanding-section">
                    <div className="pm-recon-payment-outstanding-section-list">
                      <div> Outstanding Limit</div>
                      <span>
                        {_formatCurrency(
                          props.driverReconcilationDetails.outstandingLimit || 0
                        )}
                      </span>
                    </div>
                    <div className="pm-recon-payment-outstanding-section-list">
                      <div> Previous Outstanding</div>
                      <span>
                        {_formatCurrency(
                          props.driverReconcilationDetails.previousOutstanding >
                            0
                            ? props.driverReconcilationDetails
                                .previousOutstanding || 0
                            : 0
                        )}
                      </span>
                    </div>
                    <div className="pm-recon-payment-outstanding-section-list">
                      <div> New Outstanding</div>
                      <span>
                        {_formatCurrency(
                          (props.driverReconcilationDetails.newOutstanding > 0
                            ? props.driverReconcilationDetails.newOutstanding
                            : 0) || 0
                        )}
                      </span>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <div className="pm-recon-payment-card">
              <div className="pm-recon-payment-options">
                <div className="pm-recon-payment-outstanding">
                  <div
                  className="pm-recon-payment-outstanding-title"
                    // style={{
                    //   color: "#1a1d1f",
                    //   fontWeight: "bold",
                    //   fontSize: "15px",
                    //   marginTop: "16px",
                    //   textAlign: "left",
                    //   padding: "15px",
                    // }}
                  >
                    Excess Details
                  </div>

                  <section className="pm-recon-payment-outstanding-section">
                    <div className="pm-recon-payment-outstanding-section-list">
                      <div> Previous Excess</div>
                      <span>
                        {_formatCurrency(
                          props.driverReconcilationDetails.previousExcess || 0
                        )}
                      </span>
                    </div>
                    <div className="pm-recon-payment-outstanding-section-list">
                      <div> New Excess</div>
                      <span>
                        {_formatCurrency(
                          (props.driverReconcilationDetails.newOutstanding < 0
                            ? Math.abs(
                                // parseInt(
                                // 	props.driverReconcilationDetails
                                // 		.newOutstanding,
                                // ) + props.driverReconcilationDetails.Excess,
                                props.driverReconcilationDetails
                                  .deliveriesValue -
                                  ((props.driverReconcilationDetails
                                    .driverCash || 0) +
                                    (props.driverReconcilationDetails
                                      .driverDeposit || 0) +
                                    (props.totalVirtualAmount || 0))
                              )
                            : props.driverReconcilationDetails.Excess) || 0
                        )}
                      </span>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </>
  );
};

export default withAppData(DriverReconPayment);
